<script setup lang="ts">
import {
  useRecipeBackupStore,
  useRouterStore,
  useStatsigEventsStore,
} from '@apps/main/new-desktop/core/stores';
import { HotelDetailsEventSource } from '@apps/main/new-desktop/core/models';

import type { ItineraryAccommodationUpsellSegment } from '../../../../models';
import {
  useTripOverviewPageStore,
  useTripOverviewPanelsStore,
} from '../../../../stores';

import AccommodationUpsellCard from './AccommodationUpsellCard.vue';
import AccommodationUpsellSegmentLayout from './AccommodationUpsellSegmentLayout.vue';

interface AccommodationUpsellSegmentProps {
  segment: ItineraryAccommodationUpsellSegment;
}

const props = defineProps<AccommodationUpsellSegmentProps>();

const recipeBackupStore = useRecipeBackupStore();
const routerStore = useRouterStore();
const tripOverviewPageStore = useTripOverviewPageStore();
const tripOverviewPanelsStore = useTripOverviewPanelsStore();
const statsigEventsStore = useStatsigEventsStore();

function navigateToHotelSelection(): void {
  const navigationIndex = { ingredientIndex: 1 };
  recipeBackupStore.createBackup();
  tripOverviewPageStore.addAccommodationToOwnStayIngredient(
    props.segment.context.ingredientId
  );
  routerStore.navigateToHotelSelection(navigationIndex);
  statsigEventsStore.logTripOverviewAccommodationUpsellHotelSelectionNavigation();
}

function openHotelDetails(hotelCode: string): void {
  tripOverviewPanelsStore.openHotelDetailsPanel(
    hotelCode,
    props.segment.context.ingredientId,
    { numberOfNights: props.segment.context.numberOfNights }
  );
  statsigEventsStore.logHotelDetailsInitiated({
    source: HotelDetailsEventSource.TripOverviewAccommodationUpsell,
  });
}
</script>

<template>
  <AccommodationUpsellSegmentLayout
    :segment="segment"
    @navigate-to-hotel-selection="navigateToHotelSelection"
  >
    <template #upsell-card="{ item, index }">
      <AccommodationUpsellCard
        v-if="item"
        :class="[
          {
            'accommodation-upsell-card-spacing':
              index < props.segment.productCardData.length - 1,
          },
        ]"
        :data="item"
        :contex="props.segment.context"
        @open-hotel-details="openHotelDetails($event)"
      />
    </template>
  </AccommodationUpsellSegmentLayout>
</template>

<style scoped lang="scss">
.accommodation-upsell-card-spacing {
  margin-right: var(--spacing-12);
}
</style>
